import { Box, Stack, styled } from '@mui/material';
import { colors } from '@watter/shared-components';
import { focuseEffect } from '../components/common-styles';

export const MainWrapper = styled(Box)(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.whiteSmoke,
    boxShadow: theme.palette.mode === 'dark' ? '0px 0px 30px 0px #0000001A' : '',
    padding: theme.spacing(5),
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: theme.spacing(3),
    height: 'auto',
    overflow: 'auto',
    rowGap: theme.spacing(2.5),
    '& form': {
        display: 'grid',
        gridTemplateColumns: '1fr 35%',
        gap: theme.spacing(3),
        zIndex: 0,
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column-reverse',
            gap: theme.spacing(1),
        },
    },
    '& .details': {
        '& .MuiTypography-subtitle1': {
            fontFamily: 'good_sansregular',
            color: theme.palette.mode === 'dark' ? colors?.info : colors?.gray,
        },
        '& input,.MuiSelect-select ': {
            padding: theme.spacing(1.0625, 0),
            textOverflow: 'ellipsis',
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root, .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0 0 1px 0',
                borderRadius: 0,
                borderColor: colors?.lightGray,
            },
        },
        '& .MuiInputBase-root.Mui-disabled': {
            '& .MuiInputBase-input': {
                color: theme.palette.mode === 'dark' ? colors?.white : colors?.blackColor,
                '-webkit-text-fill-color': 'inherit',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        '& .errorText': {
            color: colors?.error,
            marginLeft: '2px',
            marginTop: '5px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        '& .header': {
            fontFamily: 'good_sansbold',
        },
        '&.profileDetails': {
            '& .MuiFormControl-root': {
                marginBottom: theme.spacing(0),
            },
            '& .MuiGrid2-root': {
                '& .MuiStack-root': {
                    position: 'relative',
                    '& .MuiFormHelperText-root': {
                        position: 'absolute',
                        bottom: theme.spacing(-2.5),
                    },
                },
            },
        },
        '& .cstVerify': {
            position: 'relative',
            '& .MuiButton-root': {
                position: 'absolute',
                right: theme.spacing(0),
                top: theme.spacing(3.5),
                fontSize: theme.spacing(1.5),
                letterSpacing: 0,
                '&.verify': {
                    background: colors?.errorRedBg,
                    color: colors?.errorTextBtn,
                },
                '&.verified': {
                    background: colors?.verifyBg,
                    color: colors?.verifyText,
                },
            },
            '&.cstMobileNumber': {
                '& .MuiSelect-select': {
                    textOverflow: 'inherit',
                },
            },
        },
        '& .cstEmail': {
            '& .cstDisableEmail': {
                '& .MuiSelect-select': {
                    color: 'gray',
                },
                '& .MuiInputBase-root.Mui-disabled': {
                    '& .MuiInputBase-input': {
                        color: 'gray',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderBottom: `1px solid ${colors?.lightGray}`,
                    },
                },
            },
        },
    },

    '& .actionFooter': {
        '& .cstBtn': {
            boxShadow:
                theme.palette.mode === 'dark'
                    ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                    : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
            background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.lightBgButton,
            color: theme.palette.mode === 'dark' ? colors?.white : colors?.blackColor,
            fontSize: theme.spacing(1.75),
            padding: theme.spacing(1.5, 3),
            fontFamily: 'good_sansmedium',
            minWidth: theme.spacing(17.5),
            whiteSpace: 'nowrap',
            position: 'relative',
            '&:focus::after': focuseEffect(),
        },

        [theme.breakpoints.down('sm')]: {
            rowGap: theme.spacing(2),
            '& .MuiBox-root': {
                width: '100%',
                '& .cstBtn': {
                    minWidth: '100%',
                    '&:focus::after': focuseEffect(),
                },
            },
        },
    },
    '& .profile': {
        [theme.breakpoints.down('md')]: {
            textAlign: 'center',
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            '& img': {
                width: theme.spacing(20),
                height: theme.spacing(20),
                borderRadius: '50%',
                boxShadow: '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
            },
        },
    },
    '& .cstEditProfile': {
        '& .MuiSelect-select': {
            paddingLeft: 0,
        },
        '& .MuiSelect-nativeInput': {
            background: 'transparent',
            border: 0,
            fontFamily: 'good_sansregular',
            color: theme.palette.mode === 'dark' ? colors?.white : colors?.blackColor,
        },
    },
    '& .cstSelectProfile': {
        '& .MuiInputLabel-root': {
            left: theme.spacing(-1.75),
            color: colors?.placeholder,
            [theme.breakpoints.up('md')]: {
                top: theme.spacing(-2.375),
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderBottom: `1px solid ${colors?.lightGray} !important`,
        },
        '&.cstState': {
            '& .MuiInputLabel-root': {
                top: theme.spacing(0),
            },
            '& .MuiInputBase-root,input': {
                paddingLeft: theme.spacing(0),
                textTransform: 'capitalize',
            },
        },
    },
    '& .cstProfileImage': {
        padding: theme.spacing(0, 3.75),
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        [theme.breakpoints.down('md')]: {
            margin: 'auto',
        },
        '& .cstProfileImageStack': {
            position: 'relative',
            '& .ReactCrop': {
                zIndex: 9,
            },
            '& img': {
                borderRadius: theme.spacing(2),
            },
            '& .cstProfileImageEdit': {
                position: 'absolute',
                inset: 0,
                display: 'none',
                alignItems: 'center',
                justifyContent: 'center',
                '& input': {
                    display: 'none',
                },
                '&:hover': {
                    backdropFilter: ' brightness(0.4)',
                },
                '& .MuiIconButton-root': {
                    color: colors?.white,
                },
            },
            '&:hover': {
                '& .cstProfileImageEdit': {
                    display: 'flex',
                    cursor: 'pointer',
                },
            },
            '&.cstEmptyProfile': {
                minHeight: '300px',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: theme.palette.mode === 'dark' ? colors?.emptyImgageBg : colors?.lightGray,
                borderRadius: theme.spacing(1),
                '& .emptyBox': {
                    width: theme.spacing(3.75),
                    '& img': {
                        borderRadius: 0,
                    },
                },
            },
        },
    },
}));
export const NotifyContainer = styled(Stack)(({ theme }) => ({
    '& .cards': {
        borderRadius: theme.spacing(1),
        background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.whiteSmoke,
        '& .unread': {
            width: theme.spacing(1.75),
            height: theme.spacing(1.75),
            borderRadius: '50%',
            background: colors.verifyText,
        },
        '& .MuiSvgIcon-root[data-testid="DeleteIcon"]': {
            color: colors.astric,
        },
        '& .subText': {
            color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
        },
    },
}));
